// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__EX0YW","unreadBadge":"styles_unreadBadge__kbDa4","modalContent":"styles_modalContent__23YYz","modal":"styles_modal__1x-gj"};